var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.to)?_c('router-link',_vm._g(_vm._b({class:_vm.$style.link,attrs:{"to":_vm.to}},'router-link',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2):_c('a',_vm._g(_vm._b({class:_vm.$style.link,attrs:{"href":_vm.href}},'a',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }